module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"articles":"Articles","date":"Date","blog":"Blog","title":"Title","createArticle":"Create article"}}')
  delete Component.options._Ctor
}
